import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Paper } from '@mui/material';
import React from 'react';
export const VolunteersAdminFilterBarSurface = ({ children }) => (React.createElement(Paper, { sx: { p: 2, mb: 2, border: `1px solid ${themeColors.border.main}`, boxShadow: 'none' } }, children));
